export default __webpack_public_path__ + "static/2-b038f2338325c3fc9c516c3de62a8495.png";